import { render, staticRenderFns } from "./AccidentClassificationList.vue?vue&type=template&id=13639558"
import script from "./AccidentClassificationList.vue?vue&type=script&lang=js"
export * from "./AccidentClassificationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports